module.exports = __webpack_public_path__ + "img/vacancy_bg.1737ed76.png";